import type { LexicalNode } from "lexical";
import { SurveyAnswersNode } from "./survey-answers-node";

export function $isSurveyAnswersNode(
  node: LexicalNode | null | undefined,
): node is SurveyAnswersNode {
  return node instanceof SurveyAnswersNode;
}
